import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0467ca7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "story stroy--button" }
const _hoisted_2 = { class: "accordion" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "accordion-item__title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-box" }, " Lorem ipsum, dolor sit amet consectetur adipisicing elit. Maxime sapiente natus, iusto culpa aspernatur sed ea modi voluptatibus doloribus. Quaerat recusandae quia fuga hic quasi impedit, accusamus tempore, possimus porro, eligendi soluta delectus temporibus ab sed ad aperiam quam voluptates molestiae quo magni odio eum odit? Excepturi asperiores ullam sequi! ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spoiler = _resolveComponent("spoiler")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "accordion-item",
          onClick: ($event: any) => (_ctx.onClick(item))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", {
              class: _normalizeClass(['accordion-item__arrow', {'accordion-item__arrow--opened': item.opened}])
            }, null, 2),
            _createTextVNode(" " + _toDisplayString(item.title), 1)
          ]),
          _createVNode(_component_spoiler, {
            modelValue: item.opened,
            "onUpdate:modelValue": ($event: any) => ((item.opened) = $event)
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue"])
        ], 8, _hoisted_3))
      }), 128))
    ])
  ]))
}